import {
	APP_INIT,
	APP_SHOW_ALERT,
	APP_HIDE_ALERT,
	APP_SET_SESSION_ID,
	APP_SEARCH_CLEAR,
	APP_CACHE_FILTERS,
	APP_SEARCH_SET,
	APP_SORT_LIST,
	APP_SORT_LOADING,
} from './types'

const initialState = {
	ready: false,
	isShowAlert: false,
	alertMessage: '',
	alertType: null,
	closeTimeout: null,
	session_id: null,
	searching: null,
	search: '',
	cachedPageFilters: {},
	sortList: {},
	sortLoading: false,
}

export const state = { ...initialState }

export default {
	[APP_SORT_LIST]: (state, { data }) => {
		state.sortList = data
	},
	[APP_INIT]: (state) => {
		state.ready = true
	},
	[APP_SHOW_ALERT]: (state, payload) => {
		const { message, closeTimeout, type } = payload

		state.isShowAlert = true
		state.alertMessage = message
		state.alertType = type
		state.closeTimeout = closeTimeout
	},
	[APP_HIDE_ALERT]: (state, payload) => {
		state.isShowAlert = false
		state.alertMessage = payload
		state.closeTimeout = null
	},
	[APP_SET_SESSION_ID]: (state, id) => {
		state.session_id = id
	},
	[APP_CACHE_FILTERS]: (state, { name, filters }) => {
		state.cachedPageFilters[name] = filters
	},
	[APP_SEARCH_SET]: (state, payload) => {
		state.search = payload
	},
	[APP_SEARCH_CLEAR]: (state) => {
		state.search = ''
	},
	[APP_SORT_LOADING]: (state, payload) => {
		state.sortLoading = payload
	},
}
